(async () => {
    const { updateURLParams, requestFilter, cancelFilterRequest } = await import(window.theme.modules.utils);
    const baseComponent = await import(window.theme.modules.baseComponent);
    customElements.define('collection-sort', class extends baseComponent.default {
        elements = { select: 'select' };
        render() {
            this.acceptedSort = this.$select.value;
            this.$select.addEventListener('change', () => {
                const value = this.$select.value;
                const urls = updateURLParams({ sort_by: value, page: null }, this.sectionId);
                requestFilter(this, urls, 'sort', () => { this.acceptedSort = value; },
                    () => { this.$select.value = this.acceptedSort; }, 'sortChange');
            });
            this.handleHistory = () => { if (this.isConnected) window.location.reload(); };
        }
        reRender() { if (this.handleHistory) window.addEventListener('popstate', this.handleHistory); }
        disconnectedCallback() {
            cancelFilterRequest(this);
            window.removeEventListener('popstate', this.handleHistory);
            super.disconnectedCallback();
        }
    });
})();